<!-- Vista: Sin líneas -->
@if (!hasLines() && !isMiParcheView()) {
  <div class="max-w-6xl mx-auto p-4 sm:p-8">
    <div class="mb-8 sm:mb-12">
      <h2 class="text-3xl sm:text-4xl font-oswald text-virgin-dark mb-4">¡Güelcom!</h2>
      <p class="text-base sm:text-lg text-virgin-dark leading-relaxed">
        Nos estamos renovando para que puedas hacer todo súper rápido.<br />
        Por fa asocia tu línea, si aún no eres Virgin pásate con tu mismo número y te enviaremos la
        Sim gratis o pide una línea nuevecita.
      </p>
    </div>

    @if (error()) {
      <div class="flex items-center justify-center w-full">
        <p-message severity="error" size="small" variant="simple">{{ error() }}</p-message>
      </div>
    }

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
      <!-- Tengo línea Virgin -->
      <div class="card-virgin">
        <h3 class="text-lg font-oswald font-semibold text-virgin-dark mb-4">
          TENGO LÍNEA VIRGIN MOBILE
        </h3>
        <p class="text-sm text-gray-600 mb-6">
          Ingresa tu número Virgin y te enviaremos un mensaje de texto con un código para validar tu
          línea.
        </p>
        <app-button variant="primary" (pressed)="openAddLineModal()">Asociar mi línea</app-button>
        <!-- <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 items-end">
          <div>
            <span class="block mb-2">Línea Virgin Mobile</span>
            <p-inputmask
              mask="(399) 999-9999"
              [(ngModel)]="value"
              placeholder="(3 - - ) - - -  - - - -"
              class="w-full"
            />
          </div>
          <div>
            <button
              (click)="openAddLineModal()"
              class="btn-virgin btn btn-primary cursor-pointer w-full"
            >
              Asociar mi línea
            </button>
          </div>
        </div> -->
        <!-- <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 items-end mt-8">
          <div>
            <span class="block mb-2">Código</span>
            <p-inputmask
              mask="(399) 999-9999"
              [(ngModel)]="value"
              placeholder="(3 - - ) - - -  - - - -"
              class="w-full"
            />
          </div>
          <div>
            <button
              (click)="openAddLineModal()"
              class="btn-virgin btn btn-primary cursor-pointer w-full"
            >
              Validar
            </button>
          </div>
        </div> -->
      </div>

      <!-- Pásate a Virgin -->
      <div class="card-virgin">
        <h3 class="text-lg font-oswald font-semibold text-virgin-dark mb-4">
          PÁSATE A VIRGIN MOBILE
        </h3>
        <p class="text-sm text-gray-600 mb-3">Mantener tu mismo número</p>
        <button
          class="btn-virgin-outline w-full mb-8 cursor-pointer btn btn-primary"
          onclick="window.open('https://www.virginmobile.co/pasate/portabilidad/', '_blank')"
        >
          Solicitar Portabilidad
        </button>

        <p class="text-sm text-gray-600 mb-3">Compra una línea nueva</p>
        <button
          class="btn-virgin-outline w-full btn btn-primary cursor-pointer"
          onclick="window.open('https://www.virginmobile.co/inicio/sim-linea-nueva', '_blank')"
        >
          Comprar Sim
        </button>
      </div>
    </div>
  </div>
}

<!-- Vista Mi Parche: sin líneas propias -->
@if (!hasLines() && isMiParcheView()) {
  <div class="max-w-4xl mx-auto p-4 sm:p-8 flex flex-col gap-6">
    <div>
      <h2 class="text-3xl sm:text-4xl font-oswald text-virgin-dark mb-2">
        <span class="text-[#E10A0A]">Mi</span> Parche
      </h2>
      <p class="text-gray-600">Estas son las líneas que tienes asociadas a Mi Parche</p>
    </div>

    @if (isFFActive) {
      <div
        class="font-[Poppins] text-[#141C34] font-light w-full bg-[#F7F7F7] shadow-[0px_4px_4px_0px_#0000000D] rounded-[20px] px-6 py-4"
      >
        <h3 class="font-bold text-[clamp(12px,1.5vw,22px)]">
          <span class="text-[#E10A0A]">Mi</span> Parche
        </h3>
        <p class="text-[clamp(10px,1.5vw,16px)]">
          Arma <span class="font-bold">“<span class="span-red">Mi</span> Parche”</span> y paga
          menos, por cada amig@ o familiar que traigas (hasta 5) con un
          <span class="font-bold">plan de 30 días</span>, recibes un porcentaje de descuento. Así de
          fácil: <span class="font-bold">hasta 15% menos</span> solo por compartir lo bueno.
        </p>
      </div>
    }

    @if (error()) {
      <div class="flex items-center justify-center w-full">
        <p-message severity="error" size="small" variant="simple">{{ error() }}</p-message>
      </div>
    }

    <div class="rounded-[20px] bg-[#F7F7F7] px-6 py-8 text-center text-gray-600">
      No tienes líneas propias asociadas a Mi Parche.
    </div>
  </div>
}

<!-- Vista: Listado de líneas -->
@if (hasLines()) {
  <div class="max-w-4xl mx-auto p-4 sm:p-8 flex flex-col gap-4">
    <!-- Header -->
    <div>
      @if (isMiParcheView()) {
        <h2 class="text-3xl sm:text-4xl font-oswald text-virgin-dark mb-2">
          <span class="text-[#E10A0A]">Mi</span> Parche
        </h2>
        <p class="text-gray-600">Estas son las líneas que tienes asociadas a Mi Parche</p>
      } @else {
        <h2 class="text-3xl sm:text-4xl font-oswald text-virgin-dark mb-2">MIS LÍNEAS</h2>
        <p class="text-gray-600">Estas son las líneas que tienes asociadas a tu cuenta</p>
      }
    </div>

    @if (isFFActive && (isLegacyView() || isMiParcheView())) {
      <div
        class="font-[Poppins] text-[#141C34] font-light w-full bg-[#F7F7F7] shadow-[0px_4px_4px_0px_#0000000D] rounded-[20px] px-6 py-4"
      >
        <h3 class="font-bold font-[700] not-italic text-[clamp(12px,1.5vw,22px)]">
          <span class="text-[#E10A0A]">Mi</span> Parche
        </h3>
        <p class="text-[clamp(10px, 1.5vw, 16px)]">
          Arma <span class="font-bold">“<span class="span-red">Mi</span> Parche”</span> y paga
          menos, por cada amig@ o familiar que traigas (hasta 5) con un
          <span class="font-bold">plan de 30 días</span>, recibes un porcentaje de descuento. Así de
          fácil: <span class="font-bold">hasta 15% menos</span> solo por compartir lo bueno.
        </p>
      </div>
    }

    @if (error()) {
      <div class="flex items-center justify-center w-full">
        <p-message severity="error" size="small" variant="simple">{{ error() }}</p-message>
      </div>
    }

    <div class="mb-4">
      <span class="font-semibold text-virgin-dark">Líneas ({{ linesList().length }}):</span>
    </div>

    <!-- Lista de líneas -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
      @for (line of linesList(); track line.id) {
        <div
          class="hover:-translate-y-1 hover:shadow-virgin-lg transition-all duration-300"
          [ngClass]="{
            'w-[clamp(100%,25vw,445px)] bg-[#F7F7F7] rounded-[20px] px-6 py-4 gap-[0.70rem]':
              isFFActive,
            'w-full bg-transparent rounded-none p-0 gap-0': !isFFActive,
          }"
        >
          <!-- Contenido principal -->
          <div class="flex items-center justify-between mb-3">
            <div class="flex items-center gap-4">
              <!-- Icono -->
              <div
                class="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-virgin text-virgin-red flex-shrink-0"
              >
                <svg
                  width="22"
                  height="35"
                  viewBox="0 0 22 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.6771 4.21956L17.6472 0.144419C17.5541 0.0502328 17.4299 0 17.2995 0H0.490545C0.360147 0 0.235958 0.0502328 0.142817 0.144419C0.0496754 0.238606 0 0.364188 0 0.496049V34.4974C0 34.7737 0.21733 34.9934 0.490545 34.9934H21.1058C21.1058 34.9934 22 35.1441 22 34.0013V5.21166C22 4.53351 21.6833 4.21956 21.6833 4.21956H21.6771ZM0.98109 34.0013V0.992098H17.1008L21.0189 4.95421V34.0013H0.98109Z"
                    fill="#171D36"
                  />
                  <path
                    d="M7.75564 26.7489V30.8932H10.5064V25.9389H8.55665C8.10957 25.9389 7.74943 26.3031 7.74943 26.7552M15.1449 30.8932H16.039C17.0636 30.8932 17.8956 30.0518 17.8956 29.0157V27.4836H15.1449V30.8932ZM13.3627 25.9389H11.4937V30.8932H14.17V26.7489C14.17 26.3031 13.8098 25.9327 13.3627 25.9327M16.039 15.5721H15.1449V19.0194H17.8956V17.4496C17.8956 16.4135 17.0636 15.5721 16.039 15.5721ZM13.5304 21.6754V24.9531C14.35 25.0348 15.0082 25.6752 15.1262 26.4915H17.8956V20.0115H15.1386C15.0765 20.8905 14.3935 21.5938 13.5304 21.6754ZM4.10449 29.0157C4.10449 30.0518 4.93656 30.8932 5.96111 30.8932H6.77455V27.4836H4.10449V29.0157ZM14.1638 19.8796V15.5721H11.4875V20.6959H13.3565C13.8036 20.6959 14.1638 20.3317 14.1638 19.8796ZM8.56286 24.9468V21.688C7.61903 21.688 6.84906 20.9471 6.78076 20.0115H4.10449V26.4915H6.79938C6.92357 25.6187 7.6687 24.9468 8.56286 24.9468ZM9.54395 24.9468H12.5493V21.688H9.54395V24.9468ZM8.56286 20.6959H10.5126V15.5721H7.76184V19.8796C7.76184 20.3317 8.12199 20.6959 8.56907 20.6959M6.77455 15.5721H5.96111C4.93656 15.5721 4.10449 16.4135 4.10449 17.4496V19.0194H6.77455V15.5721Z"
                    fill="#E10F14"
                  />
                </svg>
              </div>

              <!-- Detalles -->
              <div>
                <p
                  class="font-[Poppins] font-normal text-[clamp(9.67px,1.5vw,16px)] leading-[100%] tracking-[0] text-[#141C34] mb-0 normal-case"
                >
                  {{ line.alias }}
                </p>
                <p
                  class="font-[Oswald,Helvetica,Arial,Lucida,sans-serif] font-semibold text-[clamp(14.51px,1.5vw,24px)] leading-[100%] tracking-[0] text-[#141C34] mb-0 normal-case"
                >
                  {{ formatMsisdn(line.msisdn) }}
                </p>
              </div>
            </div>

            <!-- Acciones -->
            <div class="flex items-center gap-2">
              <!-- Botón Editar (solo si es propietario) -->
              @if (line.owner) {
                <button
                  (click)="editLine(line)"
                  class="p-2 text-[#E10A0A] hover:text-virgin-red hover:bg-red-50 rounded-lg transition-colors duration-200"
                  title="Editar alias"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              }

              <!-- Botón Eliminar (solo si no es propietario) -->
              @if (!line.owner) {
                <button
                  (click)="openDeleteConfirmation(line)"
                  class="p-2 text-[#E10A0A] hover:text-virgin-red hover:bg-red-50 rounded-lg transition-colors duration-200"
                  title="Eliminar línea"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              }
            </div>
          </div>

          @if (isFFActive) {
            <div class="w-full h-px bg-[#C4C4C4] shrink-0 my-2"></div>
          }
          @if (isFFActive && (isLegacyView() || isMiParcheView()) && line.owner) {
            <div
              class="w-full flex gap-2 items-center justify-between cursor-pointer"
              (click)="goToFnFDetails(line.msisdn)"
            >
              <span class="font-bold"><span class="text-[#E10A0A]">Mi</span> Parche: </span>
              <div class="flex items-center justify-center gap-1">
                <span class="text-[#E10A0A] font-bold">{{ getFnfDiscount(line) }}</span> -
                {{ getFnfCount(line) }} integrantes
                <i class="pi pi-chevron-right"></i>
              </div>
            </div>
          }

          <!-- Estado de propiedad en Mis Líneas -->
          @if (!isLegacyView() && !isMiParcheView() && line.owner) {
            <div class="flex items-center gap-2 p-2 rounded-lg">
              <i class="pi pi-check-circle text-green-600"></i>
              <span class="text-sm text-gray-600">Propietario</span>
            </div>
          }

          <!-- Warning si no es propietario -->
          @if (!isMiParcheView() && !line.owner) {
            <div class="flex items-center gap-2 p-2 rounded-lg">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="#06b4f8"
                class="text-virgin-red"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 8v4m0 4h.01" stroke="white" stroke-width="2" stroke-linecap="round" />
              </svg>
              <span class="text-sm text-virgin-red">No eres propietario de esta línea</span>
            </div>
          }
        </div>
      }
    </div>

    @if (!isMiParcheView()) {
      <div class="mx-auto w-full flex items-center justify-center">
        <app-fnf-buttons
          [buttonProps]="{
            text: '+ Añadir línea',
            variant: 'primary',
          }"
          (onClick)="openAddLineModal()"
        />
      </div>
    }
  </div>
}

<app-fnf-base-dialog
  [visible]="showAddLineModal()"
  (onClose)="closeAddLineModal()"
  subject="AÑADIR LÍNEA"
  class="w-[clamp(269px,80vw,600px)]"
>
  <!-- Body -->
  <p class="text-gray-600 mb-6">
    Ingresa tu número Virgin y te enviaremos un mensaje de texto con un código para validar tu
    línea.
  </p>

  <form [formGroup]="newLineForm" class="w-full">
    <!-- Input de número -->
    <div class="flex flex-col sm:flex-row gap-3 mb-4 sm:items-end">
      <div class="flex-1">
        <label for="newMsisdn" class="block font-semibold text-virgin-dark mb-2 text-sm">
          Línea Virgin Mobile
        </label>
        <p-inputMask
          #newMsisdn
          id="newMsisdn"
          mask="( 999 ) 999 - 9999"
          formControlName="newMsisdn"
          (onComplete)="validateNewMsisdn()"
          unmask="true"
          placeholder="( ) - "
          slotChar=" "
          required
          type="tel"
          class="w-100"
          [style]="{
            border: 'none',
            width: '100%',
            'box-shadow': 'none',
            'border-bottom': '1px solid #939393',
            'background-color': '#fcfcfc',
            padding: '1rem',
            color: '#555555',
            'font-family': 'Raleway',
          }"
        >
        </p-inputMask>
      </div>

      <app-fnf-buttons
        [buttonProps]="{
          text: lblButtonSendCode(),
          variant: lblButtonSendCode() === 'Enviar' ? 'primary' : 'outline',
        }"
        (onClick)="sendSMSCode()"
      />
    </div>

    <!-- Input de código SMS -->
    @if (codeSended()) {
      <div class="flex flex-col sm:flex-row gap-3 sm:items-end">
        <div class="flex-1">
          <label for="smsCode" class="block font-semibold text-virgin-dark mb-2 text-sm">
            Código SMS
          </label>
          <input
            id="smsCode"
            maxlength="7"
            pKeyFilter="int"
            type="tel"
            formControlName="smsCode"
            class="w-100"
            [style]="{
              border: 'none',
              width: '100%',
              'box-shadow': 'none',
              'border-bottom': '1px solid #939393',
              'background-color': '#fcfcfc',
              padding: '1rem',
              color: '#555555',
              'font-family': 'Raleway',
            }"
          />
        </div>
        <app-fnf-buttons
          [buttonProps]="{
            isDisabled: newLineForm.get('smsCode')?.invalid ?? false,
            text: 'Validar',
            variant: 'primary',
          }"
          (onClick)="validateCodeSMS()"
        />
      </div>
    }
  </form>

  @if (error()) {
    <div class="flex items-center justify-center w-full">
      <p-message severity="error" size="small" variant="simple">{{ error() }}</p-message>
    </div>
  }
</app-fnf-base-dialog>

<!-- Modal: Confirmar eliminación -->
<app-fnf-action-dialog
  [visible]="showDeleteModal()"
  (onClose)="showDeleteModal.set(false)"
  (onAction)="deleteLineConfirmed()"
  [dialogProps]="fnfActionDialogMeta()"
/>

<!-- Modal: Éxito -->
<app-fnf-success-dialog
  [visible]="showSuccessModal()"
  (onClose)="showSuccessModal.set(false)"
  [dialogProps]="fnfSuccessDialogMeta()"
/>
